<template>
  <ClientOnly>
    <div v-if="notifications.length" class="notifications">
      <div
        v-for="n in notifications"
        :key="n.id"
        class="notification"
        :class="`notification-${n.type}`"
      >
        <span class="notification-msg">{{ n.message }}</span>
        <button class="notification-close" @click="remove(n.id)">✕</button>
      </div>
    </div>
  </ClientOnly>
</template>

<script setup lang="ts">
const { notifications, remove } = useNotification();
</script>
